<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="modalLicense"
    title="🔑 License"
    size="md"
    ok-title="Close"
    ok-only
  >
    <b-row>
      <!-- GATEWAY NAME -->

      <b-col cols="12">
        <b-table
          responsive
          :items="items"
          :fields="fields"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BTable,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BTable,
  },
  data() {
    return {
      fields: [
        {
          key: 'LicenseID',
          label: 'ID',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'License_Key',
          label: 'License Key',
          sortable: false,
          class: 'text-center',
          thStyle: { background: 'rgb(255, 177, 0,0.7)' },
          tdClass: 'bg-light-warning',
        },
      ],
      items: [],
      anydesk: '',
    }
  },
  computed: {
    // sortOptions() {
    //   // Create an options list from our fields
    //   return this.fields
    //     .filter(f => f.sortable)
    //     .map(f => ({ text: f.label, value: f.key }))
    // },
  },
  mounted() {
  },
  methods: {
    getLicense(value) {
      this.pid = value
      axios
        .post('/getLicenseCount', { wid: value })
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
</style>
